export const dateReformatting = (dateString: string): string => {
  const dateStringSplit = dateString.split('-')
  return `${dateStringSplit[2]}.${dateStringSplit[1]}.${dateStringSplit[0]}`
}
